import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, ContractDto, ContractReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import ContractInline from "./ContractInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: ContractDto | ContractReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function ContractLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.ContractRead]}
      to={ROUTE_PATH.CONTRACT_VIEW(entity?.id || entityId || "")}
      content={<ContractInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
